<script>
  import { emitter } from '@/main.js';
  import storefront from '@/lib/storefront.js';
  import * as queries from '@/lib/queries.js';
  import { whenFastSimonReady } from '@/lib/vue-helpers.js';
  import CompleteTheLookDisplay from '@/components/CompleteTheLookDisplay.vue';
  export default {
    name: 'CompleteTheLook',
    components: {
      CompleteTheLookDisplay
    },
    props: {
      handle: {
        type: String,
        required: true
      },
      tags: {
        type: Array,
        required: true
      },
      pid: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        hasProducts: false,
        ctlFinalEmpty: false,
        // isBundle only resolves once ColorVariantOption answers ctl-request-bundle-children, which
        // is after the first render. Seeded from the mount node so bundles never paint a reservation
        // they would immediately drop. Read here rather than in mounted() for the same reason.
        serverIsBundle: document.getElementById('CompleteTheLook')?.getAttribute('data-is-bundle') === 'true',
        raw_description: '',
        displayDataList: '',
        reactiveCtlImageTags: '',
        raw_accordian_1: '',
        raw_accordian_2: '',
        raw_accordian_3: '',
        raw_accordian_4: '',
        raw_accordian_5: '',
        accordian_title_1: '',
        accordian_title_2: '',
        accordian_title_3: '',
        accordian_title_4: '',
        accordian_title_5: '',
        displayAccordianData_1: '',
        displayAccordianData_2: '',
        displayAccordianData_3: '',
        displayAccordianData_4: '',
        displayAccordianData_5: '',
        accordian_list_1_li: '',
        accordian_list_2_li: '',
        accordian_list_3_li: '',
        accordian_list_4_li: '',
        accordian_list_5_li: '',
        title_5: '',
        raw_content_5: '',
        title_5_int: '',
        raw_content_5_override_tag: '',
        raw_content_5_override: '',
        raw_content_5_override_canada: '',
        ctl_title: '',
        upsell_product_list: '',
        upsell_product_list_value: '',
        upsell_list_limit: '',
        countryCode: '',
        localHandle: this.handle,
        localPid: this.pid,
        ctlFsWidgetId: '',
        ctlFsExcludeTag: '',
        localTags: [],
        openClass: 'accordion-is-open',
        loading: true,
        currentVariantMetafields: {},
        metafieldResponseCache: {},
        variantMetafieldMapHandle: '',
        variantMetafieldRequest: null,
        ctl_position: false,
        SoldOutText: '',
        addToCartText: '',
        comingsoonText: '',
        comingsoon_tag: '',
        UnavailableText: '',
        optiontwoorder: '',
        optiontwoorderoverride: '',
        optiontwoorderoverridetag: '',
        optionthreeorder: '',
        isBundle: false,
        lineItemsStandalone: false,
        bundleHandles: [],
        bundleChildren: [],
        bundlePanels: [],
        show_image_2: false,
        show_image_3: false,
        ctlSource: '',
        barRatingTitle: '',
        bar_rating_position: false,
        barRatingFilled: '',
        barRatingUnfilled: '',
        barRatingTextColor: '',
        barRatingLineHeight: '',
        barRatingLineGap: '',
        barRatingOpen: false,
        rawBarRatings: ['', '', '', '', '']
      };
    },
    mounted() {
      this.localTags = this.tags;
      this.countryCode = window.Shopify.country;
      this.optiontwoorder = this.$el.parentElement.getAttribute('data-optiontwoorder');
      this.optiontwoorderoverride = this.$el.parentElement.getAttribute('data-optiontwoorderoverride');
      this.optiontwoorderoverridetag = this.$el.parentElement.getAttribute('data-optiontwoorderoverridetag');
      this.optionthreeorder = this.$el.parentElement.getAttribute('data-optionthreeorder');
      this.show_image_2 = this.$el.parentElement.getAttribute('data-show-image-2') === 'true';
      this.show_image_3 = this.$el.parentElement.getAttribute('data-show-image-3') === 'true';
      this.raw_description = this.$el.parentElement.getAttribute('data-description_list');
      this.lineItemsStandalone = this.$el.parentElement.getAttribute('data-line_items_standalone') === 'true';
      this.reactiveCtlImageTags = this.$el.parentElement.dataset.reactiveCtlImageTags;
      this.raw_accordian_1 = this.$el.parentElement.getAttribute('data-accordian_list_1');
      this.raw_accordian_2 = this.$el.parentElement.getAttribute('data-accordian_list_2');
      this.raw_accordian_3 = this.$el.parentElement.getAttribute('data-accordian_list_3');
      this.raw_accordian_4 = this.$el.parentElement.getAttribute('data-accordian_list_4');
      this.raw_accordian_5 = this.$el.parentElement.getAttribute('data-accordian_list_5');
      this.accordian_title_1 = this.$el.parentElement.getAttribute('data-accordian_title_1');
      this.accordian_title_2 = this.$el.parentElement.getAttribute('data-accordian_title_2');
      this.accordian_title_3 = this.$el.parentElement.getAttribute('data-accordian_title_3');
      this.accordian_title_4 = this.$el.parentElement.getAttribute('data-accordian_title_4');
      this.accordian_title_5 = this.$el.parentElement.getAttribute('data-accordian_title_5');
      this.accordian_list_1_li = this.$el.parentElement.getAttribute('data-accordian_list_1_li');
      this.accordian_list_2_li = this.$el.parentElement.getAttribute('data-accordian_list_2_li');
      this.accordian_list_3_li = this.$el.parentElement.getAttribute('data-accordian_list_3_li');
      this.accordian_list_4_li = this.$el.parentElement.getAttribute('data-accordian_list_4_li');
      this.accordian_list_5_li = this.$el.parentElement.getAttribute('data-accordian_list_5_li');
      this.title_5 = this.$el.parentElement.getAttribute('data-title_5');
      this.raw_content_5 = this.$el.parentElement.getAttribute('data-raw_content_5');
      this.title_5_int = this.$el.parentElement.getAttribute('data-title_5_int');
      this.raw_content_5_override_tag = this.$el.parentElement.getAttribute('data-raw_content_5_override_tag');
      this.raw_content_5_override = this.$el.parentElement.getAttribute('data-raw_content_5_override');
      this.raw_content_5_override_canada = this.$el.parentElement.getAttribute('data-raw_content_5_override_canada');
      this.ctl_title = this.$el.parentElement.getAttribute('data-ctl_title');
      this.upsell_product_list = this.$el.parentElement.getAttribute('data-upsell_product_list');
      this.upsell_list_limit = this.$el.parentElement.getAttribute('data-upsell_list_limit');
      this.ctl_position = this.$el.parentElement.getAttribute('data-ctl_position');
      this.addToCartText = this.$el.parentElement.getAttribute('data-addToCartText');
      this.SoldOutText = this.$el.parentElement.getAttribute('data-SoldOutText');
      this.comingsoon_tag = this.$el.parentElement.getAttribute('data-comingsoon_tag');
      this.comingsoonText = this.$el.parentElement.getAttribute('data-comingsoonText');
      this.UnavailableText = this.$el.parentElement.getAttribute('data-UnavailableText');
      this.ctlFsWidgetId = this.$el.parentElement.getAttribute('data-ctl-fs-widget-id') || '';
      this.ctlFsExcludeTag = this.$el.parentElement.getAttribute('data-ctl-fs-exclude-tag') || '';
      this.barRatingTitle = this.$el.parentElement.getAttribute('data-bar_rating_title') || 'Best For';
      this.bar_rating_position = this.$el.parentElement.getAttribute('data-bar_rating_position');
      this.barRatingFilled = this.$el.parentElement.getAttribute('data-bar_rating_filled') || '#151515';
      this.barRatingUnfilled = this.$el.parentElement.getAttribute('data-bar_rating_unfilled') || '#cacaca';
      this.barRatingTextColor = this.$el.parentElement.getAttribute('data-bar_rating_text_color') || '#151515';
      this.barRatingLineHeight = this.$el.parentElement.getAttribute('data-bar_rating_line_height') || '10';
      this.barRatingLineGap = this.$el.parentElement.getAttribute('data-bar_rating_line_gap') || '16';
      this.rawBarRatings = [
        this.$el.parentElement.getAttribute('data-bar_rating_1') || '',
        this.$el.parentElement.getAttribute('data-bar_rating_2') || '',
        this.$el.parentElement.getAttribute('data-bar_rating_3') || '',
        this.$el.parentElement.getAttribute('data-bar_rating_4') || '',
        this.$el.parentElement.getAttribute('data-bar_rating_5') || ''
      ];

      //first time loading, move to function
      this.loading = true;
      this.cleanRawSettings(this.raw_description, 'list');
      this.cleanRawSettings(this.raw_accordian_1, 'accordian_1');
      this.cleanRawSettings(this.raw_accordian_2, 'accordian_2');
      this.cleanRawSettings(this.raw_accordian_3, 'accordian_3');
      this.cleanRawSettings(this.raw_accordian_4, 'accordian_4');
      this.cleanRawSettings(this.raw_accordian_5, 'accordian_5');
      this.cleanRawSettings(this.upsell_product_list, 'CTL');

      emitter.on('pdp-handle-updated', e => {
        // For bundle products, keep CTL metafield loading on the parent bundle handle
        if (this.isBundle) {
          return;
        }
        if (e.handle !== this.localHandle) {
          this.loading = true;
          this.ctlSource = '';
          this.ctlFinalEmpty = false;
          this.localHandle = e.handle;
          this.variantMetafieldMapHandle = '';
          this.variantMetafieldRequest = null;
          // Drop the previous product's responses, or a variant selection arriving before the
          // refetches below land would re-render the accordions from the old handle's values.
          this.metafieldResponseCache = {};
          this.currentVariantMetafields = {};
          this.cleanRawSettings(this.raw_description, 'list');
          this.cleanRawSettings(this.raw_accordian_1, 'accordian_1');
          this.cleanRawSettings(this.raw_accordian_2, 'accordian_2');
          this.cleanRawSettings(this.raw_accordian_3, 'accordian_3');
          this.cleanRawSettings(this.raw_accordian_4, 'accordian_4');
          this.cleanRawSettings(this.raw_accordian_5, 'accordian_5');
          this.cleanRawSettings(this.upsell_product_list, 'CTL');
        }
      });

      emitter.on('pdp-tags-updated', e => {
        this.localTags = e.tags;
        if (e.pid) this.localPid = e.pid;
      });

      emitter.on('bundle-children-meta-updated', this.handleBundleChildrenMetaUpdated);
      emitter.on('variant-color-selected', this.handleVariantColorSelected);
      emitter.on('updateAddButton', this.handleVariantMetafieldSelection);

      // Request current bundle children after CTL is mounted
      emitter.emit('ctl-request-bundle-children');
    },
    beforeUnmount() {
      emitter.off('bundle-children-meta-updated', this.handleBundleChildrenMetaUpdated);
      emitter.off('variant-color-selected', this.handleVariantColorSelected);
      emitter.off('updateAddButton', this.handleVariantMetafieldSelection);
    },

    methods: {
      handleVariantColorSelected(e) {
        if (this.isBundle) return;
        if (e.description === undefined) return;
        const descEl = document.querySelector('#product-description-pdp');
        if (descEl) descEl.innerHTML = e.description;
      },
      syncStandaloneLineItems() {
        if (!this.lineItemsStandalone) return;
        const el = document.querySelector('.additional-details--standalone');
        if (!el) return;
        // Bundles list per-child items, which only this component can resolve, so the
        // server-rendered parent list steps aside. Visibility is otherwise the server's
        // call, including its own hide-me for an empty list.
        if (this.isBundle) el.classList.add('hide-me');
      },
      handleBundleChildrenMetaUpdated(payload) {
        const handles = Array.isArray(payload?.children) && payload.children.length ? payload.children.map(child => child?.handle).filter(handle => typeof handle === 'string' && handle.length) : [];
        this.bundleChildren = Array.isArray(payload?.children) && payload.children.length ? payload.children.filter(child => child && child.handle) : [];
        this.bundleHandles = handles;
        this.isBundle = handles.length > 0;
        this.syncStandaloneLineItems();
        if (this.isBundle) {
          this.loadBundlePanels();
          this.cleanRawSettings(this.raw_description, 'list');
          this.cleanRawSettings(this.raw_accordian_1, 'accordian_1');
          this.cleanRawSettings(this.raw_accordian_2, 'accordian_2');
          this.cleanRawSettings(this.raw_accordian_3, 'accordian_3');
          this.cleanRawSettings(this.raw_accordian_4, 'accordian_4');
          this.cleanRawSettings(this.raw_accordian_5, 'accordian_5');
          this.cleanRawSettings(this.upsell_product_list, 'CTL');
        }
      },
      firstBundlePanel() {
        return Array.isArray(this.bundlePanels) && this.bundlePanels.length ? this.bundlePanels[0] : null;
      },
      ctlHasWidget() {
        return this.showMetafieldValue(this.upsell_product_list_value) && this.hasProducts;
      },
      ctlShowPlaceholder() {
        // Bundle PDPs render CTL from a child panel that may never emit ctl-products-updated, so
        // reserving space there risks a permanent gap or premature collapse; scope it to non-bundle.
        if (this.isBundle || this.serverIsBundle) {
          return false;
        }
        return !this.ctlHasWidget() && !this.ctlFinalEmpty;
      },
      cleanRawSettings(data, type) {
        if (data == null || typeof data !== 'string') {
          return;
        }
        const cleanedData = [];
        const lines = data.split(/\r?\n/);
        lines.forEach(item => {
          let group = item.split(',');
          if (this.isValueMetafiledKey(group[0])) {
            cleanedData.push(this.splitMetaFieldTextSetting(group[0]));
          }
          if (this.isValueMetafiledKey(group[1])) {
            cleanedData.push(this.splitMetaFieldTextSetting(group[1]));
          }
        });

        emitter.on('pdp-tags-updated', e => {
          this.localTags = e.tags;
        });

        emitter.on('updateAddButton', e => {
          this.instock = e.instock;
          this.notavail = e.notavail;
        });

        emitter.on('ctl-products-updated', e => {
          this.hasProducts = e.hasProducts;
          // This event only fires after the metafield ids (or the FastSimon fallback) have been
          // resolved, so a false here means there is genuinely nothing to show -> release the space.
          if (!e.hasProducts) {
            this.ctlFinalEmpty = true;
          }
        });
        this.getMetafields(cleanedData, type);
      },
      getRawByType(dataType, rawOverrides = {}) {
        const override = rawOverrides[dataType];
        if (typeof override === 'string') {
          return override;
        }
        if (dataType === 'list') return this.raw_description;
        if (dataType === 'accordian_1') return this.raw_accordian_1;
        if (dataType === 'accordian_2') return this.raw_accordian_2;
        if (dataType === 'accordian_3') return this.raw_accordian_3;
        if (dataType === 'accordian_4') return this.raw_accordian_4;
        if (dataType === 'accordian_5') return this.raw_accordian_5;
        return '';
      },

      handleResponse(data, dataType, target = this, rawOverrides = {}) {
        if (dataType !== 'CTL') {
          data = Array.isArray(data) ? data : [];
        }
        const cleanedData = [];

        const rawText = this.getRawByType(dataType, rawOverrides);
        const lines = rawText ? rawText.split(/\r?\n/) : [];
        if (dataType === 'CTL') {
          if (target !== this) {
            target.upsell_product_list_value = data?.[0]?.value || '';
          } else {
            const NewList = data?.[0]?.value;
            if (NewList && (Array.isArray(NewList) ? NewList.length > 0 : true)) {
              // CompleteTheLookDisplay only emits ctl-products-updated from its own mount, and it
              // remounts only when these ids change its :key. Clearing hasProducts when the ids are
              // identical would hide the widget with no event coming to bring it back.
              if (JSON.stringify(NewList) !== JSON.stringify(this.upsell_product_list_value || [])) {
                this.hasProducts = false;
              }
              this.upsell_product_list_value = NewList;
              this.ctlSource = 'metafield';
            } else {
              this.upsell_product_list_value = [];
              this.fetchCTLFromFS();
            }
          }
          return;
        }

        // Variant-scoped tokens are resolved from the selected variant, not from this response,
        // so they must not advance `index` - the response only holds the product-level values.
        if (target === this) {
          this.metafieldResponseCache[dataType] = data;
        }

        let index = 0;
        lines.forEach(item => {
          var displayLine = [];
          let group = item.split(',');
          if (this.isVariantMetafieldKey(group[0])) {
            displayLine[0] = this.variantMetafieldValue(group[0]);
          } else if (this.isValueMetafiledKey(group[0])) {
            displayLine[0] = data[index]?.value || '';
            index++;
          } else {
            displayLine[0] = group[0];
          }
          if (this.isVariantMetafieldKey(group[1])) {
            displayLine[1] = this.variantMetafieldValue(group[1]);
          } else if (this.isValueMetafiledKey(group[1])) {
            displayLine[1] = data[index]?.value || '';
            index++;
          } else {
            displayLine[1] = group[1];
          }
          // A single-token line has no comma, so `group[1]` is undefined and passes this filter -
          // that undefined is load-bearing. Normalizing it to '' would make the line fail its own
          // filter and silently disappear.
          if (displayLine[0] !== '' && displayLine[1] !== '') {
            cleanedData.push(displayLine);
          }
        });
        if (dataType === 'list') {
          target.displayDataList = cleanedData;
        }
        if (dataType === 'accordian_1') {
          target.displayAccordianData_1 = cleanedData;
        }
        if (dataType === 'accordian_2') {
          target.displayAccordianData_2 = cleanedData;
        }
        if (dataType === 'accordian_3') {
          target.displayAccordianData_3 = cleanedData;
        }
        if (dataType === 'accordian_4') {
          target.displayAccordianData_4 = cleanedData;
        }
        if (dataType === 'accordian_5') {
          target.displayAccordianData_5 = cleanedData;
        }
      },

      buildMetaIdentifiersFromRaw(raw) {
        const identifiers = [];
        if (!raw) return identifiers;
        const lines = raw.split(/\r?\n/);
        lines.forEach(item => {
          const group = item.split(',');
          if (this.isValueMetafiledKey(group[0])) {
            identifiers.push(this.splitMetaFieldTextSetting(group[0]));
          }
          if (this.isValueMetafiledKey(group[1])) {
            identifiers.push(this.splitMetaFieldTextSetting(group[1]));
          }
        });
        return identifiers;
      },

      async loadBundlePanels() {
        if (!this.bundleChildren.length) {
          return;
        }
        const panels = await Promise.all(this.bundleChildren.map(child => this.fetchBundlePanel(child)));
        this.bundlePanels = panels.filter(Boolean);
      },

      async fetchBundlePanel(child = {}) {
        const handle = child?.handle;
        const panel = {
          handle,
          title: child?.title || handle || '',
          displayDataList: [],
          displayAccordianData_1: [],
          displayAccordianData_2: [],
          displayAccordianData_3: [],
          displayAccordianData_4: [],
          displayAccordianData_5: [],
          upsell_product_list_value: ''
        };

        const descriptors = [
          { type: 'list', raw: this.raw_description },
          { type: 'accordian_1', raw: this.raw_accordian_1 },
          { type: 'accordian_2', raw: this.raw_accordian_2 },
          { type: 'accordian_3', raw: this.raw_accordian_3 },
          { type: 'accordian_4', raw: this.raw_accordian_4 },
          { type: 'accordian_5', raw: this.raw_accordian_5 },
          { type: 'CTL', raw: this.upsell_product_list }
        ];

        const allIdentifiers = [];
        const typeRanges = [];
        for (const desc of descriptors) {
          const identifiers = this.buildMetaIdentifiersFromRaw(desc.raw);
          if (!identifiers.length) continue;
          typeRanges.push({ type: desc.type, raw: desc.raw, start: allIdentifiers.length, count: identifiers.length });
          allIdentifiers.push(...identifiers);
        }

        if (!allIdentifiers.length) return panel;

        try {
          const response = await storefront.request(queries.metafieldsByProductHandle, {
            variables: {
              handle,
              countryIso2: this.countryCode,
              metaIdentifier: allIdentifiers
            }
          });
          const metafields = response?.data?.product?.metafields || [];
          for (const range of typeRanges) {
            const slice = metafields.slice(range.start, range.start + range.count);
            this.handleResponse(slice, range.type, panel, { [range.type]: range.raw });
          }
        } catch (error) {
          console.error('[CompleteTheLook] Error fetching bundle metafields', { handle, error });
        }

        if (Array.isArray(panel.upsell_product_list_value)) {
          panel.upsell_product_list_value = JSON.stringify(panel.upsell_product_list_value);
        }
        return panel;
      },

      isValueMetafiledKey(val) {
        if (typeof val !== 'undefined') {
          if (val.startsWith('custom.') || val.startsWith('my_fields.') || val.startsWith('plytix.')) {
            return true;
          }
        }
        return false;
      },
      // Variant-scoped settings keep the namespace.key convention behind a `variant.` scope
      // prefix. The prefix is what disambiguates them: merch loads these into the same `custom`
      // namespace as the product-level ones, so the namespace alone can't tell the two apart.
      isVariantMetafieldKey(val) {
        return typeof val === 'string' && val.trim().startsWith('variant.');
      },
      variantMetafieldKey(val) {
        if (!this.isVariantMetafieldKey(val)) return '';
        return val.trim().replace('variant.', '');
      },
      variantMetafieldValue(val) {
        const key = this.variantMetafieldKey(val);
        if (!key) return '';
        const value = this.currentVariantMetafields[key];
        if (value === null || value === undefined) return '';
        return value;
      },
      variantMetafieldIdentifiers() {
        const identifiers = [];
        const seen = [];
        const raws = [this.raw_description, this.raw_accordian_1, this.raw_accordian_2, this.raw_accordian_3, this.raw_accordian_4, this.raw_accordian_5];
        raws.forEach(raw => {
          if (!raw) return;
          raw.split(/\r?\n/).forEach(line => {
            line.split(',').forEach(part => {
              const scopedKey = this.variantMetafieldKey(part);
              if (!scopedKey || seen.includes(scopedKey)) return;
              const namespace = scopedKey.split('.')[0];
              const key = scopedKey.split('.').slice(1).join('.');
              if (!namespace || !key) return;
              seen.push(scopedKey);
              identifiers.push({ namespace, key });
            });
          });
        });
        return identifiers;
      },
      normalizeVariantId(id) {
        if (id === null || id === undefined) return '';
        return String(id).split('/').pop();
      },
      async handleVariantMetafieldSelection(payload) {
        if (!payload) return;
        if (!this.variantMetafieldIdentifiers().length) return;

        // `updateAddButton` is a shared bus event. The PDP variant path always sends the
        // `variantMetafields` key, using null for "no pre-serialized data reached us, run the
        // fallback"; an empty object means the variant genuinely has no value. Other emitters
        // (the Outfit Picker) omit the key, so an absent key is a foreign payload about another
        // product - running the fallback on its variant id would miss and blank the fit lines.
        let values = payload.variantMetafields;
        if (values === undefined) return;

        const variantId = this.normalizeVariantId(payload.variantId);
        if (values === null && variantId) {
          const requestedHandle = this.localHandle;
          values = await this.fetchVariantMetafieldValues(variantId);
          // A handle change while the request was in flight leaves these values describing the
          // product we are no longer showing.
          if (this.localHandle !== requestedHandle) return;
          if (values === null) return;
        }

        this.currentVariantMetafields = values || {};
        this.refreshVariantAccordions();
      },
      refreshVariantAccordions() {
        Object.keys(this.metafieldResponseCache).forEach(dataType => {
          this.handleResponse(this.metafieldResponseCache[dataType], dataType);
        });
      },
      // The map carries an entry for every variant of the current product, so a miss means the id
      // belongs to a different product. Returning null rather than {} lets the caller tell that
      // apart from a variant of ours that simply has no values, and keep the current lines.
      async fetchVariantMetafieldValues(variantId) {
        const map = await this.ensureVariantMetafieldMap();
        if (!map) return null;
        return map[variantId] || null;
      },
      ensureVariantMetafieldMap() {
        const handle = this.localHandle;
        if (!handle) return Promise.resolve(null);
        if (this.variantMetafieldMapHandle === handle && this.variantMetafieldRequest) {
          return this.variantMetafieldRequest;
        }

        const identifiers = this.variantMetafieldIdentifiers();
        if (!identifiers.length) return Promise.resolve(null);

        this.variantMetafieldMapHandle = handle;
        this.variantMetafieldRequest = storefront
          .request(queries.variantMetafieldsByProductHandle, {
            variables: {
              handle,
              countryIso2: this.countryCode,
              metaIdentifier: identifiers
            }
          })
          .then(response => {
            const edges = response?.data?.product?.variants?.edges || [];
            const map = {};
            edges.forEach(edge => {
              const node = edge?.node;
              if (!node?.id) return;
              const values = {};
              (node.metafields || []).forEach(field => {
                if (!field?.namespace || !field?.key) return;
                if (field.value === null || field.value === undefined || field.value === '') return;
                values[`${field.namespace}.${field.key}`] = field.value;
              });
              map[this.normalizeVariantId(node.id)] = values;
            });
            return map;
          })
          .catch(() => ({}));

        return this.variantMetafieldRequest;
      },
      splitMetaFieldTextSetting(name) {
        let metaObj = {};
        if (name) {
          const splited = name.split('.');
          metaObj = { namespace: splited[0].trim(), key: splited[1].trim() };
          return metaObj;
        }
        return '';
      },
      checkForLIValues(val) {
        if (val) {
          if (val.startsWith('<li>')) {
            return '<ul>' + val + '</ul>';
          } else {
            return val;
          }
        }
      },
      checkForSpaceValues(val) {
        if (val) {
          if (val.startsWith(':')) {
            return val.trim();
          } else {
            return ' ' + val.trim();
          }
        }
      },
      checkForQuote(val) {
        return val.replaceAll('"', '');
      },
      showMetafieldValue(value) {
        if (Array.isArray(value)) return value.length > 0;
        return value !== '' && typeof value !== 'undefined';
      },
      getMetafields(metaId, dataType) {
        const requestHandle = this.isBundle ? this.handle : this.localHandle;
        if (requestHandle) {
          storefront
            .request(queries.metafieldsByProductHandle, {
              variables: {
                handle: requestHandle,
                countryIso2: this.countryCode,
                metaIdentifier: metaId
              }
            })
            .then(response => {
              // A slower earlier request (including the mount fetch) must not repaint the
              // specs after a colorway switch has already moved on. The newer request still
              // owns `loading`, so bail without clearing it.
              if (requestHandle !== (this.isBundle ? this.handle : this.localHandle)) return;
              this.handleResponse(response?.data?.product?.metafields, dataType);
              this.loading = false;
            })
            .catch(() => {
              // Same staleness rule as the success arm: a superseded request must not report,
              // or a failure for the previous colorway would hide the widget that already
              // loaded for this one, with no event coming to bring it back.
              if (requestHandle !== (this.isBundle ? this.handle : this.localHandle)) return;
              this.loading = false;
              // Nothing else will report on this request, so release any reserved CTL space
              // rather than leaving a gap on the PDP for the rest of the session.
              if (dataType === 'CTL') {
                emitter.emit('ctl-products-updated', { hasProducts: false });
              }
            });
        }
      },
      handleReturnMessage() {
        let message = '';
        let overrideTagTrue = this.localTags.includes(this.raw_content_5_override_tag);
        let canada = window.Shopify.country === 'CA';

        if (canada) {
          if (overrideTagTrue) {
            message = this.raw_content_5_override_canada;
          } else {
            message = this.title_5_int;
          }
        } else if (overrideTagTrue) {
          message = this.raw_content_5_override;
        } else {
          message = this.raw_content_5;
        }
        return message;
      },
      handleCTLTitle() {
        return this.ctl_title;
      },
      triggerDrawerClasses(drawIndex) {
        document.getElementById(drawIndex).classList.toggle(this.openClass);
      },
      toggleBarRatingAccordion() {
        this.barRatingOpen = !this.barRatingOpen;
        this.triggerDrawerClasses(this.handleize(this.barRatingTitle));
      },
      handleize(str) {
        return str.replaceAll(' ', '-').toLowerCase();
      },
      hasAccordionData(index) {
        const key = `displayAccordianData_${index}`;
        if (this.isBundle) {
          return this.bundlePanels.some(p => p[key] && p[key].length > 0);
        }
        return this.showMetafieldValue(this[key]);
      },
      parsedBarRatings() {
        const rows = [];
        for (const raw of this.rawBarRatings) {
          if (!raw || !raw.trim()) continue;
          const parts = raw.split('|');
          if (parts.length < 2) continue;
          const label = parts[0].trim();
          const value = Math.min(5, Math.max(0, parseInt(parts[1].trim(), 10)));
          if (!label || isNaN(value)) continue;
          rows.push({ label, value });
          if (rows.length >= 5) break;
        }
        return rows;
      },
      showBarRatings() {
        return this.parsedBarRatings().length >= 3;
      },
      barRatingCSSVars() {
        return {
          '--bar-filled': this.barRatingFilled,
          '--bar-unfilled': this.barRatingUnfilled,
          '--bar-text-color': this.barRatingTextColor,
          '--bar-line-height': `${this.barRatingLineHeight}px`,
          '--bar-line-gap': `${this.barRatingLineGap}px`
        };
      },
      checkForDetailsDisplayClass(items) {
        let classes = 'additional-details gt-p';
        if (!items || !items.length) {
          classes = classes += ' hide-me';
        }
        return classes;
      },
      fetchCTLFromFS() {
        if (this.ctlFsExcludeTag && this.localTags.includes(this.ctlFsExcludeTag)) {
          emitter.emit('ctl-products-updated', { hasProducts: false });
          return;
        }
        if (!this.ctlFsWidgetId) {
          emitter.emit('ctl-products-updated', { hasProducts: false });
          return;
        }
        whenFastSimonReady(
          () => {
            window.FastSimonSDK.productRecommendationByWidget({
              productID: this.localPid,
              withAttributes: false,
              widgetsIDS: [this.ctlFsWidgetId],
              callback: response => {
                const products = response?.payload?.[0]?.payload || [];
                if (products.length > 0) {
                  const gids = products.map(product => `gid://shopify/Product/${product.id}`);
                  this.upsell_product_list_value = gids;
                  this.ctlSource = 'fs';
                } else {
                  this.upsell_product_list_value = [];
                  emitter.emit('ctl-products-updated', { hasProducts: false });
                }
              }
            });
          },
          // The SDK never arriving is indistinguishable from it returning nothing, as far as the
          // reserved space is concerned — either way there is no widget coming.
          { onTimeout: () => emitter.emit('ctl-products-updated', { hasProducts: false }) }
        );
      }
    }
  };
</script>

<template>
  <div :class="checkForDetailsDisplayClass(isBundle ? bundlePanels.flatMap(p => p.displayDataList) : lineItemsStandalone ? [] : displayDataList)">
    <template v-if="!isBundle && !lineItemsStandalone">
      <ul>
        <template v-for="(item, index) in displayDataList" :key="index + '-product'">
          <li v-if="item[0] != '' && item[1] != ''"><b v-html="this.checkForQuote(item[0])"></b><span v-html="this.checkForSpaceValues(item[1])"></span></li>
        </template>
      </ul>
    </template>
    <template v-else>
      <template v-for="panel in bundlePanels" :key="panel.handle + '-bundle-display-list'">
        <p class="bundle-ctl__child-title gt-p__bold">{{ panel.title }}</p>
        <ul v-if="panel.displayDataList && panel.displayDataList.length">
          <template v-for="(item, index) in panel.displayDataList" :key="panel.handle + '-product-' + index">
            <li v-if="item[0] != '' && item[1] != ''"><b v-html="this.checkForQuote(item[0])"></b><span v-html="this.checkForSpaceValues(item[1])"></span></li>
          </template>
        </ul>
      </template>
    </template>
  </div>

  <template v-if="ctl_position == 'true'">
    <div v-if="ctlShowPlaceholder()" class="ctl-space-reservation"></div>
    <div :class="'accordion accordion__wrapper ' + openClass + (ctlSource === 'fs' ? ' ctl--fs-powered' : '')" v-if="!isBundle && this.showMetafieldValue(upsell_product_list_value)" :id="handleize(handleCTLTitle())" :style="{ display: hasProducts ? 'block' : 'none' }">
      <label class="accordion accordion__title gt-p__bold" v-html="handleCTLTitle()" @click.prevent="triggerDrawerClasses(handleize(handleCTLTitle()))"></label>
      <div class="accordion accordion__body gt-p" :key="upsell_product_list_value + '-top'">
        <CompleteTheLookDisplay :SoldOutText="SoldOutText" :addToCartText="addToCartText" :unavailableText="UnavailableText" :comingsoonText="comingsoonText" :comingsoon_tag="comingsoon_tag" :ctlIds="upsell_product_list_value || '[]'" :optiontwoorder="optiontwoorder" :optiontwoorderoverride="optiontwoorderoverride" :optiontwoorderoverridetag="optiontwoorderoverridetag" :optionthreeorder="optionthreeorder" :reactive-ctl-tags="reactiveCtlImageTags" :show-image-2="show_image_2" :show-image-3="show_image_3"></CompleteTheLookDisplay>
      </div>
    </div>
    <template v-else>
      <div v-if="firstBundlePanel() && this.showMetafieldValue(firstBundlePanel().upsell_product_list_value)" :class="'accordion accordion__wrapper ' + openClass + (ctlSource === 'fs' ? ' ctl--fs-powered' : '')" :id="handleize(handleCTLTitle()) + '-' + firstBundlePanel().handle" :style="{ display: hasProducts ? 'block' : 'none' }">
        <label class="accordion accordion__title gt-p__bold" v-html="handleCTLTitle()" @click.prevent="triggerDrawerClasses(handleize(handleCTLTitle()) + '-' + firstBundlePanel().handle)"></label>
        <div class="accordion accordion__body gt-p">
          <p class="bundle-ctl__child-title gt-p__bold">
            {{ firstBundlePanel().title }}
          </p>
          <CompleteTheLookDisplay :SoldOutText="SoldOutText" :addToCartText="addToCartText" :unavailableText="UnavailableText" :comingsoonText="comingsoonText" :comingsoon_tag="comingsoon_tag" :ctlIds="firstBundlePanel().upsell_product_list_value || '[]'" :optiontwoorder="optiontwoorder" :optiontwoorderoverride="optiontwoorderoverride" :optiontwoorderoverridetag="optiontwoorderoverridetag" :optionthreeorder="optionthreeorder" :reactive-ctl-tags="reactiveCtlImageTags"></CompleteTheLookDisplay>
        </div>
      </div>
    </template>
  </template>

  <template v-if="bar_rating_position == 'true' && showBarRatings()">
    <div class="accordion accordion__wrapper" :id="handleize(barRatingTitle)" :style="barRatingCSSVars()">
      <button
        type="button"
        class="accordion accordion__title gt-p__bold"
        v-html="barRatingTitle"
        :aria-controls="handleize(barRatingTitle) + '-body'"
        :aria-expanded="barRatingOpen.toString()"
        @click.prevent="toggleBarRatingAccordion()"
      ></button>
      <div class="accordion accordion__body gt-p" :id="handleize(barRatingTitle) + '-body'">
        <div class="pdp-bar-ratings">
          <div
            class="pdp-bar-rating-row"
            v-for="(rating, index) in parsedBarRatings()"
            :key="'bar-rating-top-' + index"
            role="img"
            :aria-label="`${rating.label}: ${rating.value} out of 5`"
          >
            <span class="pdp-bar-rating-label">{{ rating.label }}</span>
            <div class="pdp-bar-rating-blocks">
              <span
                v-for="b in 5"
                :key="'bar-top-' + index + '-' + b"
                class="pdp-bar-rating-block"
                :class="b <= rating.value ? 'pdp-bar-rating-block--filled' : 'pdp-bar-rating-block--empty'"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <template v-if="accordian_title_1 != '' && hasAccordionData(1)">
    <div class="accordion accordion__wrapper" :id="handleize(accordian_title_1)">
      <label class="accordion accordion__title gt-p__bold" v-html="accordian_title_1" @click.prevent="triggerDrawerClasses(handleize(accordian_title_1))"></label>
      <div class="accordion accordion__body gt-p">
        <template v-if="!isBundle">
          <ul v-if="accordian_list_1_li != 'true'">
            <template v-for="(item, index) in displayAccordianData_1" :key="index + '-items'">
              <li v-if="item[0] != '' && item[1] != ''">
                <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
              </li>
            </template>
          </ul>
          <template v-else>
            <ul>
              <template v-for="(item, index) in displayAccordianData_1" :key="index + '-items'">
                <template v-if="item[0] != '' && item[1] != ''">
                  <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                  <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                </template>
              </template>
            </ul>
          </template>
        </template>
        <template v-else>
          <template v-for="panel in bundlePanels" :key="panel.handle + '-acc1-section'">
            <div v-if="panel.displayAccordianData_1 && panel.displayAccordianData_1.length" class="bundle-ctl__panel-group">
              <p class="bundle-ctl__child-title gt-p__bold">
                {{ panel.title }}
              </p>
              <ul v-if="accordian_list_1_li != 'true'">
                <template v-for="(item, index) in panel.displayAccordianData_1" :key="panel.handle + '-acc1-item-' + index">
                  <li v-if="item[0] != '' && item[1] != ''">
                    <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                    <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                  </li>
                </template>
              </ul>
              <template v-else>
                <ul>
                  <template v-for="(item, index) in panel.displayAccordianData_1" :key="panel.handle + '-acc1-inline-' + index">
                    <template v-if="item[0] != '' && item[1] != ''">
                      <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                      <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                    </template>
                  </template>
                </ul>
              </template>
            </div>
          </template>
        </template>
      </div>
    </div>
  </template>

  <template v-if="accordian_title_2 != '' && hasAccordionData(2)">
    <div class="accordion accordion__wrapper" :id="handleize(accordian_title_2)">
      <label class="accordion accordion__title gt-p__bold" v-html="accordian_title_2" @click.prevent="triggerDrawerClasses(handleize(accordian_title_2))"></label>
      <div class="accordion accordion__body gt-p">
        <template v-if="!isBundle">
          <ul v-if="accordian_list_2_li != 'true'">
            <template v-for="(item, index) in displayAccordianData_2" :key="index + '-items'">
              <li v-if="item[0] != '' && item[1] != ''">
                <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
              </li>
            </template>
          </ul>
          <template v-else>
            <ul>
              <template v-for="(item, index) in displayAccordianData_2" :key="index + '-items'">
                <template v-if="item[0] != '' && item[1] != ''">
                  <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                  <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                </template>
              </template>
            </ul>
          </template>
        </template>
        <template v-else>
          <template v-for="panel in bundlePanels" :key="panel.handle + '-acc2-section'">
            <div v-if="panel.displayAccordianData_2 && panel.displayAccordianData_2.length" class="bundle-ctl__panel-group">
              <p class="bundle-ctl__child-title gt-p__bold">
                {{ panel.title }}
              </p>
              <ul v-if="accordian_list_2_li != 'true'">
                <template v-for="(item, index) in panel.displayAccordianData_2" :key="panel.handle + '-acc2-item-' + index">
                  <li v-if="item[0] != '' && item[1] != ''">
                    <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                    <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                  </li>
                </template>
              </ul>
              <template v-else>
                <ul>
                  <template v-for="(item, index) in panel.displayAccordianData_2" :key="panel.handle + '-acc2-inline-' + index">
                    <template v-if="item[0] != '' && item[1] != ''">
                      <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                      <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                    </template>
                  </template>
                </ul>
              </template>
            </div>
          </template>
        </template>
      </div>
    </div>
  </template>

  <template v-if="accordian_title_3 != '' && hasAccordionData(3)">
    <div class="accordion accordion__wrapper" :id="handleize(accordian_title_3)">
      <label class="accordion accordion__title gt-p__bold" v-html="accordian_title_3" @click.prevent="triggerDrawerClasses(handleize(accordian_title_3))"></label>
      <div class="accordion accordion__body gt-p">
        <template v-if="!isBundle">
          <ul v-if="accordian_list_3_li != 'true'">
            <template v-for="(item, index) in displayAccordianData_3" :key="index + '-items'">
              <li v-if="item[0] != '' && item[1] != ''">
                <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
              </li>
            </template>
          </ul>
          <template v-else>
            <ul>
              <template v-for="(item, index) in displayAccordianData_3" :key="index + '-items'">
                <template v-if="item[0] != '' && item[1] != ''">
                  <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                  <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                </template>
              </template>
            </ul>
          </template>
        </template>
        <template v-else>
          <template v-for="panel in bundlePanels" :key="panel.handle + '-acc3-section'">
            <div v-if="panel.displayAccordianData_3 && panel.displayAccordianData_3.length" class="bundle-ctl__panel-group">
              <p class="bundle-ctl__child-title gt-p__bold">
                {{ panel.title }}
              </p>
              <ul v-if="accordian_list_3_li != 'true'">
                <template v-for="(item, index) in panel.displayAccordianData_3" :key="panel.handle + '-acc3-item-' + index">
                  <li v-if="item[0] != '' && item[1] != ''">
                    <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                    <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                  </li>
                </template>
              </ul>
              <template v-else>
                <ul>
                  <template v-for="(item, index) in panel.displayAccordianData_3" :key="panel.handle + '-acc3-inline-' + index">
                    <template v-if="item[0] != '' && item[1] != ''">
                      <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                      <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                    </template>
                  </template>
                </ul>
              </template>
            </div>
          </template>
        </template>
      </div>
    </div>
  </template>

  <template v-if="accordian_title_4 != '' && hasAccordionData(4)">
    <div class="accordion accordion__wrapper" :id="handleize(accordian_title_4)">
      <label class="accordion accordion__title gt-p__bold" v-html="accordian_title_4" @click.prevent="triggerDrawerClasses(handleize(accordian_title_4))"></label>
      <div class="accordion accordion__body gt-p">
        <template v-if="!isBundle">
          <ul v-if="accordian_list_4_li != 'true'">
            <template v-for="(item, index) in displayAccordianData_4" :key="index + '-items'">
              <li v-if="item[0] != '' && item[1] != ''">
                <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
              </li>
            </template>
          </ul>
          <template v-else>
            <ul>
              <template v-for="(item, index) in displayAccordianData_4" :key="index + '-items'">
                <template v-if="item[0] != '' && item[1] != ''">
                  <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                  <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                </template>
              </template>
            </ul>
          </template>
        </template>
        <template v-else>
          <template v-for="panel in bundlePanels" :key="panel.handle + '-acc4-section'">
            <div v-if="panel.displayAccordianData_4 && panel.displayAccordianData_4.length" class="bundle-ctl__panel-group">
              <p class="bundle-ctl__child-title gt-p__bold">
                {{ panel.title }}
              </p>
              <ul v-if="accordian_list_4_li != 'true'">
                <template v-for="(item, index) in panel.displayAccordianData_4" :key="panel.handle + '-acc4-item-' + index">
                  <li v-if="item[0] != '' && item[1] != ''">
                    <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                    <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                  </li>
                </template>
              </ul>
              <template v-else>
                <ul>
                  <template v-for="(item, index) in panel.displayAccordianData_4" :key="panel.handle + '-acc4-inline-' + index">
                    <template v-if="item[0] != '' && item[1] != ''">
                      <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                      <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                    </template>
                  </template>
                </ul>
              </template>
            </div>
          </template>
        </template>
      </div>
    </div>
  </template>

  <template v-if="accordian_title_5 != '' && hasAccordionData(5)">
    <div class="accordion accordion__wrapper" :id="handleize(accordian_title_5)">
      <label class="accordion accordion__title gt-p__bold" v-html="accordian_title_5" @click.prevent="triggerDrawerClasses(handleize(accordian_title_5))"></label>
      <div class="accordion accordion__body gt-p">
        <template v-if="!isBundle">
          <ul v-if="accordian_list_5_li != 'true'">
            <template v-for="(item, index) in displayAccordianData_5" :key="index + '-items'">
              <li v-if="item[0] != '' && item[1] != ''">
                <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
              </li>
            </template>
          </ul>
          <template v-else>
            <ul>
              <template v-for="(item, index) in displayAccordianData_5" :key="index + '-items'">
                <template v-if="item[0] != '' && item[1] != ''">
                  <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                  <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                </template>
              </template>
            </ul>
          </template>
        </template>
        <template v-else>
          <template v-for="panel in bundlePanels" :key="panel.handle + '-acc5-section'">
            <div v-if="panel.displayAccordianData_5 && panel.displayAccordianData_5.length" class="bundle-ctl__panel-group">
              <p class="bundle-ctl__child-title gt-p__bold">
                {{ panel.title }}
              </p>
              <ul v-if="accordian_list_5_li != 'true'">
                <template v-for="(item, index) in panel.displayAccordianData_5" :key="panel.handle + '-acc5-item-' + index">
                  <li v-if="item[0] != '' && item[1] != ''">
                    <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                    <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                  </li>
                </template>
              </ul>
              <template v-else>
                <ul>
                  <template v-for="(item, index) in panel.displayAccordianData_5" :key="panel.handle + '-acc5-inline-' + index">
                    <template v-if="item[0] != '' && item[1] != ''">
                      <span v-html="this.checkForQuote(item[0])" v-if="this.checkForQuote(item[0]) != ''"></span>
                      <span v-html="this.checkForSpaceValues(item[1])" v-if="this.checkForSpaceValues(item[1])"></span>
                    </template>
                  </template>
                </ul>
              </template>
            </div>
          </template>
        </template>
      </div>
    </div>
  </template>

  <template v-if="ctl_position == 'false'">
    <div v-if="ctlShowPlaceholder()" class="ctl-space-reservation"></div>
    <div :class="'accordion accordion__wrapper ' + openClass + (ctlSource === 'fs' ? ' ctl--fs-powered' : '')" v-if="!isBundle && this.showMetafieldValue(upsell_product_list_value)" :id="handleize(handleCTLTitle())" :style="{ display: hasProducts ? 'block' : 'none' }">
      <label class="accordion accordion__title gt-p__bold" v-html="handleCTLTitle()" @click.prevent="triggerDrawerClasses(handleize(handleCTLTitle()))"></label>
      <div class="accordion accordion__body gt-p" :key="upsell_product_list_value + '-bottom'">
        <CompleteTheLookDisplay :SoldOutText="SoldOutText" :addToCartText="addToCartText" :unavailableText="UnavailableText" :comingsoonText="comingsoonText" :comingsoon_tag="comingsoon_tag" :ctlIds="upsell_product_list_value || '[]'" :optiontwoorder="optiontwoorder" :optiontwoorderoverride="optiontwoorderoverride" :optiontwoorderoverridetag="optiontwoorderoverridetag" :optionthreeorder="optionthreeorder" :reactive-ctl-tags="reactiveCtlImageTags" :show-image-2="show_image_2" :show-image-3="show_image_3"></CompleteTheLookDisplay>
      </div>
    </div>
    <template v-else>
      <div v-if="firstBundlePanel() && this.showMetafieldValue(firstBundlePanel().upsell_product_list_value)" :class="'accordion accordion__wrapper ' + openClass + (ctlSource === 'fs' ? ' ctl--fs-powered' : '')" :id="handleize(handleCTLTitle()) + '-' + firstBundlePanel().handle + '-bottom'">
        <label class="accordion accordion__title gt-p__bold" v-html="handleCTLTitle()" @click.prevent="triggerDrawerClasses(handleize(handleCTLTitle()) + '-' + firstBundlePanel().handle + '-bottom')"></label>
        <div class="accordion accordion__body gt-p">
          <p class="bundle-ctl__child-title gt-p__bold">
            {{ firstBundlePanel().title }}
          </p>
          <CompleteTheLookDisplay :SoldOutText="SoldOutText" :addToCartText="addToCartText" :unavailableText="UnavailableText" :comingsoonText="comingsoonText" :comingsoon_tag="comingsoon_tag" :ctlIds="firstBundlePanel().upsell_product_list_value || '[]'" :optiontwoorder="optiontwoorder" :optiontwoorderoverride="optiontwoorderoverride" :optiontwoorderoverridetag="optiontwoorderoverridetag" :optionthreeorder="optionthreeorder" :reactive-ctl-tags="reactiveCtlImageTags"></CompleteTheLookDisplay>
        </div>
      </div>
    </template>
  </template>

  <template v-if="bar_rating_position == 'false' && showBarRatings()">
    <div class="accordion accordion__wrapper" :id="handleize(barRatingTitle)" :style="barRatingCSSVars()">
      <button
        type="button"
        class="accordion accordion__title gt-p__bold"
        v-html="barRatingTitle"
        :aria-controls="handleize(barRatingTitle) + '-body'"
        :aria-expanded="barRatingOpen.toString()"
        @click.prevent="toggleBarRatingAccordion()"
      ></button>
      <div class="accordion accordion__body gt-p" :id="handleize(barRatingTitle) + '-body'">
        <div class="pdp-bar-ratings">
          <div
            class="pdp-bar-rating-row"
            v-for="(rating, index) in parsedBarRatings()"
            :key="'bar-rating-bottom-' + index"
            role="img"
            :aria-label="`${rating.label}: ${rating.value} out of 5`"
          >
            <span class="pdp-bar-rating-label">{{ rating.label }}</span>
            <div class="pdp-bar-rating-blocks">
              <span
                v-for="b in 5"
                :key="'bar-bottom-' + index + '-' + b"
                class="pdp-bar-rating-block"
                :class="b <= rating.value ? 'pdp-bar-rating-block--filled' : 'pdp-bar-rating-block--empty'"
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>

  <div class="accordion accordion__wrapper" :id="handleize(this.title_5)">
    <label class="accordion accordion__title gt-p__bold" v-html="this.title_5" @click.prevent="triggerDrawerClasses(handleize(this.title_5))"></label>
    <div class="accordion accordion__body gt-p" v-html="handleReturnMessage()"></div>
  </div>
</template>

<style lang="scss">
  .hidden-ctl {
    height: 1px;
    overflow: hidden;
    border-top: 0;
  }

  .accordion__wrapper.accordion {
    .accordion__body {
      transition: all 0.4s;
      max-height: 0;
    }
  }

  .accordion__wrapper.accordion-is-open {
    .accordion__body {
      p {
        margin-bottom: 0.75rem;
      }
    }
  }

  .accordion__wrapper.accordion-is-open.accordion {
    .accordion__body {
      display: block;
      max-height: 1200px;
    }

    .accordion__title:after {
      transform: rotate(-45deg);
    }
  }
</style>
